module.exports = __webpack_public_path__ + "static/img/1-1.1174797.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/1-1.png
// module id = VhCd
// module chunks = 0